/**
 * Recently Viewed Venues Management
 * Uses localStorage to persist recently viewed venues
 */

const STORAGE_KEY = 'recentlyViewedVenues';
const MAX_ITEMS = 10;

/**
 * Add a venue to recently viewed list
 */
export const addRecentlyViewed = (venue) => {
  try {
    // Support both _id and id field names
    const venueId = venue._id || venue.id;
    
    if (!venue || !venueId) {
      console.warn('Invalid venue data for recently viewed', venue);
      return [];
    }
    
    // Get existing list
    const existing = getRecentlyViewed();
    
    // Create simplified venue object to save space
    const venueData = {
      _id: venueId, // Store with _id for consistency
      name: venue.name,
      slug: venue.slug,
      cityName: venue.cityName,
      districtName: venue.districtName,
      images: venue.images?.[0] || venue.images || null, // Handle both array and string
      rating: venue.rating || 0,
      isClaimed: venue.isClaimed || false,
      viewedAt: new Date().toISOString()
    };
    
    console.log('📝 Adding to recently viewed:', venueData.name, venueId);
    
    // Remove if already exists (to avoid duplicates)
    const filtered = existing.filter(v => v._id !== venueId);
    
    console.log('📊 Existing count:', existing.length);
    console.log('📊 After filter:', filtered.length);
    
    // Add to beginning
    const updated = [venueData, ...filtered].slice(0, MAX_ITEMS);
    
    console.log('📊 Updated count:', updated.length);
    
    // Save to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    
    console.log('✅ Saved to localStorage');
    
    return updated;
  } catch (error) {
    console.error('Error adding to recently viewed:', error);
    return [];
  }
};

/**
 * Get recently viewed venues
 */
export const getRecentlyViewed = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    
    const venues = JSON.parse(stored);
    
    // Filter out old entries (older than 30 days)
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    
    const filtered = venues.filter(v => {
      if (!v.viewedAt) return true; // Keep if no date
      return new Date(v.viewedAt) > thirtyDaysAgo;
    });
    
    // Update storage if we filtered anything
    if (filtered.length !== venues.length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    }
    
    return filtered;
  } catch (error) {
    console.error('Error getting recently viewed:', error);
    return [];
  }
};

/**
 * Clear recently viewed venues
 */
export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing recently viewed:', error);
    return false;
  }
};

/**
 * Get time ago string (e.g., "2 saat önce")
 */
export const getTimeAgo = (dateString) => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 60) {
      return `${diffMins} dakika önce`;
    } else if (diffHours < 24) {
      return `${diffHours} saat önce`;
    } else if (diffDays < 7) {
      return `${diffDays} gün önce`;
    } else {
      return date.toLocaleDateString('tr-TR');
    }
  } catch (error) {
    return '';
  }
};
